@if (!preparingDownload) {
  <div
    class="download"
    (click)="downloadFile(dataSourceId)"
  >
    <div
      [innerHTML]="downloadIcon"
    ></div>
    @if (extension) {
      <div
        [innerText]="extension"
        class="extension"
      ></div>
    }
  </div>
} @else {
  <div
    class="download"
  >
    <motn-spinner></motn-spinner>
  </div>
}
